// @ts-nocheck
import { getCanonical } from "@insite/mobius/utilities/linkElementsManipulation";

const updateCanonical = (search: string) => {
    const element = document.querySelector('link[rel="canonical"]');
    if (element) {
        const currentCanonical = URL.parse ? URL.parse(element?.getAttribute("href") ?? "") : undefined; // Store Custom Code
        if (currentCanonical) {
            currentCanonical.search = search;
            element?.setAttribute("href", currentCanonical.toString());
        } else {
            element?.setAttribute("href", getCanonical() + search);
        }
    } else {
        const e = document.createElement("link");
        e?.setAttribute("rel", "canonical");
        e?.setAttribute("href", getCanonical() + search);
        document.head.appendChild(e);
    }
};

export { updateCanonical };
